import Vue from 'vue'
import AuthComponent from './index.vue'

const AuthConstructor = Vue.extend(AuthComponent)

const auth = {
    install: function () {
        const instance = new AuthConstructor()
        instance.id = Math.random().toString(16).substr(2)
        instance.vm = instance.$mount()
        document.body.appendChild(instance.vm.$el)

        Object.defineProperty(Vue.prototype, '$auth', {
            get () {
                return instance.vm
            }
        })
    }
}

export default auth